// Import: Middleware Action & Custom Types
import {
  CLEAN_ORDER_VINCULATION_LIST,
  CLEAN_ORDER_VINCULATION_LIST_ERROR,
} from '_models/redux/types';

// Action function
export const orderVinculationListClean = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      type: CLEAN_ORDER_VINCULATION_LIST,
      payload: undefined,
    });
  } catch (e) {
    dispatch({
      type: CLEAN_ORDER_VINCULATION_LIST_ERROR,
      payload: undefined,
    });
  }
};
